import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class CouponService extends BaseService {

    static url = "checkout-coupons";
    static apis = {
        modifyOrderCoupons: { path: this.url + "/modifyOrderCoupons", method: "post" },
        getOrderCoupons: function (order_id) {
            return { path: 'checkout-coupons' + `/order/${order_id}/coupons`, method: "get" }
        }
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("orders");
    }

    modifyOrderCoupons(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CouponService.apis.modifyOrderCoupons.path,
                method: CouponService.apis.modifyOrderCoupons.method,
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }


    getOrderCoupons(order_id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                url: CouponService.apis.getOrderCoupons(order_id).path,
                method: CouponService.apis.getOrderCoupons(order_id).method,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }
}

export default CouponService;